/* global __STATIC_PATH__ */

export const SFX = 'sfx';
export const MUSIC = 'music';
export const CONNECTOR = 'connector';
export const SILENCE = 'silence';

export const MOOD_CHILL = 1;
export const MOOD_POWER = 2;

export const SFX_PATH = `${ __STATIC_PATH__ }/audio/sfx/`;
export const MUSIC_PATH = `${ __STATIC_PATH__ }/audio/music/`;

export const FADE_DURATION = 3;

// extension element id
export const EXTENSION_ID = 'audio-extension';
export const SFX_CLICK_FILE = 'GenericClick';
